import { useAssetActionModalStore } from '@/store/asset-action-modal.store';
import { ListViewItem } from '@ingka/list-view';
import { translate } from '@repo/phrase';
import { isOrder } from '@repo/types/order';
import { invariant } from '@repo/utils/type.utils';

import { MODAL } from '@/components/modals/asset-modal.types';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { preventCancelation } from '@/utils/asset.utils';

import type { AssetActionProps } from '../../asset-context-buttons.types';

const AssetCancelListItem = ({ onClose, context }: AssetActionProps) => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const setActiveModal = useAssetActionModalStore((state) => state.setActiveModal);

    invariant(isOrder(data));

    const { isButtonDisabled } = preventCancelation(data);

    return (
        <ListViewItem
            disabled={isButtonDisabled}
            data-testid="order_status_header_cancel"
            title={translate('order_status_header_cancel')}
            control="navigational"
            controlIcon={context === 'modal' ? 'chevronRight' : null}
            inset={context === 'dropdown'}
            emphasised={context === 'modal'}
            onClick={() => {
                setActiveModal(MODAL.CANCEL);
                onClose?.();
            }}
        />
    );
};

export const AssetCancelAction = ({ type, ...props }: AssetActionProps) => {
    if (type === 'button') {
        return null;
    }
    return <AssetCancelListItem key="cancel-list-item" {...props} />;
};
